import React from "react";
import { Button } from "aible";
import * as RelationUtils from "utils/relation";
import ToolsIcon from "images/SenseIcons/tools-light 2.svg";
import RelationAccordion from "./RelationAccordion";
import RelationLineage from "./RelationLineage";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCompressArrowsAlt, faExpandArrowsAlt } from "@fortawesome/free-solid-svg-icons";
import styles from "components/Tiles/Sense/style.module.css";
import { LineInput } from "components/Inputs/LineInput";
import { TargetInput } from "./TargetInput";
import { useSelector, useDispatch } from "types/store";
import { getDraft, rebaseDraftOnSection, submitDraft, updateDraftName, updateDraftTarget, updateDraftTargetValue, updateSectionDraft } from "containers/Relation/reducer";
import { getIsOpenDataEvaluated, getIsOpenTransformations } from "containers/Sense/dataset-selectors";
import { updateTileState } from "containers/Sense/reducer";
export const RelationSavePanel = ({ datasetId, onSubmit, draft, context, baseList, hasChanges, errors }) => {
    const dispatch = useDispatch();
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { style: { marginBottom: "10px" } },
            React.createElement(TargetInput, { key: baseList.length, context: context, target: draft.target, targetValue: draft.targetValue, onTargetChange: (target) => dispatch(updateDraftTarget(datasetId, target)), onTargetValueChange: (value) => dispatch(updateDraftTargetValue(datasetId, value)) })),
        React.createElement("div", { className: styles.tFooter },
            React.createElement("div", { className: styles.nameInput },
                React.createElement(LineInput, { value: draft.name, onChange: (val) => dispatch(updateDraftName(datasetId, val ?? "")) })),
            React.createElement(Button, { type: "primary", onClick: () => dispatch(submitDraft(datasetId)).then(() => {
                    onSubmit?.();
                }), disabled: draft.isSubmitting || !hasChanges || errors.length > 0, title: errors.length > 0 ? "Errors detected in transformations. Please review pending transformations." : undefined }, draft.isSubmitting ? "Saving" : "Save As"))));
};
const RelationTile = ({ datasetId, forceIsOpen, onSubmit }) => {
    const dispatch = useDispatch();
    const isOpen = forceIsOpen ?? useSelector((state) => getIsOpenTransformations(state, datasetId));
    const isOpenDataEvaluated = useSelector((state) => getIsOpenDataEvaluated(state, datasetId));
    const toggleIsOpen = () => {
        if (forceIsOpen === undefined) {
            dispatch(updateTileState(datasetId, { isOpenTransformations: !isOpen }));
        }
    };
    const draft = useSelector((state) => getDraft(state, datasetId));
    const base = draft.base;
    const context = RelationUtils.getOutputContext(base);
    const baseList = RelationUtils.toList(base);
    const errors = RelationUtils.validate(base);
    const priorUpdates = [];
    const pendingUpdates = [];
    let hitPrior = false;
    for (const r of baseList) {
        if (r.tag?.dataset_id == draft.referenceDatasetId) {
            hitPrior = true;
            priorUpdates.push(r);
        }
        else if (r.type !== "DATA_SOURCE" && hitPrior) {
            pendingUpdates.push(r);
        }
        else {
            priorUpdates.push(r);
        }
    }
    return (React.createElement("div", { className: isOpen ? styles.openOverview : styles.overview, style: {
            maxHeight: isOpen ? "5000px" : "190px",
            width: isOpen || isOpenDataEvaluated ? "calc(100% - 20px)" : "calc(33.333% - 14px)",
            overflow: isOpen ? "visible" : "hidden",
            marginLeft: isOpen || isOpenDataEvaluated ? "10px" : "0px",
            zIndex: 155
        }, onClick: () => !isOpen && toggleIsOpen() },
        React.createElement("div", { className: styles.senseTitle },
            React.createElement("div", { className: styles.sTitle },
                React.createElement("span", { className: styles.sIcon },
                    React.createElement("img", { src: ToolsIcon, style: { height: "16px", width: "16px" } })),
                React.createElement("span", null, "Transformations")),
            forceIsOpen === undefined &&
                (isOpen ? (React.createElement("div", { className: styles.closeButton, onClick: () => toggleIsOpen() },
                    React.createElement(Button, { style: { padding: "3px" } },
                        React.createElement("div", { className: styles.selIcon, title: "Close" },
                            React.createElement(FontAwesomeIcon, { icon: faCompressArrowsAlt }))))) : (React.createElement("div", { className: styles.selIcon + " " + styles.expandIcon },
                    React.createElement(FontAwesomeIcon, { icon: faExpandArrowsAlt }))))),
        React.createElement(RelationLineage, { datasetId: datasetId, isMinimized: !isOpen, defaultOpenLineageSection: "pending" }),
        isOpen && (React.createElement(React.Fragment, null,
            React.createElement("div", { className: styles.accordionHolder },
                React.createElement(RelationAccordion, { datasetId: datasetId, draft: draft, rebaseDraftOnSection: (key) => dispatch(rebaseDraftOnSection(datasetId, key)), updateSectionDraft: (key, value) => dispatch(updateSectionDraft(datasetId, key, value)) })),
            React.createElement(RelationSavePanel, { datasetId: datasetId, onSubmit: onSubmit, context: context, draft: draft, baseList: baseList, errors: errors, hasChanges: pendingUpdates.length > 0 })))));
};
export default RelationTile;
